import { createRoute } from '@signal/router';
import { ACCOUNT } from './core';
export var AUDIENCES = createRoute(ACCOUNT, 'audiences');
export var AUDIENCE_DETAIL = createRoute(AUDIENCES, ':audienceId/edit');
export var AUDIENCE_CREATE = createRoute(AUDIENCES, 'create');